import {
  SvgIconProps,
  Tooltip as MaterialTooltip,
  TooltipProps as MaterialTooltipProps,
  useTheme,
} from '@mui/material';
import { QuestionCircleOutline } from '@portals/icons/src/QuestionCircleOutline/QuestionCircleOutline';
import React from 'react';

import type { Theme } from '../../themes/themes';
import { IconButton } from '../IconButton/IconButton';

export type TooltipProps = Omit<MaterialTooltipProps, 'children'> & {
  iconProps?: {
    htmlColor?: SvgIconProps['htmlColor'];
    fontSize?: SvgIconProps['fontSize'];
  };
};

const DEFAULT_ICON_PROPS_FONT_SIZE = 'medium';

export const TooltipButton = React.forwardRef<HTMLDivElement, TooltipProps>(({ iconProps = {}, ...props }, ref) => {
  const theme = useTheme<Theme>();

  return (
    <MaterialTooltip enterTouchDelay={0} leaveTouchDelay={2000} {...props} ref={ref}>
      <IconButton disablePadding component="button" color="secondary">
        <QuestionCircleOutline
          htmlColor={iconProps.htmlColor || theme['palette'].labeling['inputDefault']}
          fontSize={iconProps.fontSize || DEFAULT_ICON_PROPS_FONT_SIZE}
        />
      </IconButton>
    </MaterialTooltip>
  );
});

TooltipButton.displayName = 'TooltipButton';
